<div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12 px-0">
    <p class="title mt-5 mb-3">{{ copyService.copies.product_info.title }}</p>
    <p class="subtitle mb-4">{{ copyService.copies.product_info.subtitle }}</p>
    <div class="mb-5" *ngFor="let data of characteristics">
        <p class="product_title mb-2">{{ data.title }}</p>
        <p class="product_subtitle mb-2">{{ data.subtitle }}</p>
        <vcl-accordion-group>
            <vcl-accordion *ngFor="let items of data.dataSource" accordionTitle="{{ items.title }}">
                <p class="content_accordion">{{ items.description }}</p>
            </vcl-accordion>
        </vcl-accordion-group>
    </div>
</div>
<app-controls class="mt-5" [hasPrevious]="true" [nextLabel]="copyService.copies.product_info.continue"  (next)="next()"></app-controls>
